import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MovementOrdersComponent } from './component/movement-orders.component';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MovementOrderDetailsComponent } from './component/movement-order-details/movement-order-details.component';

import { TmcYardCommonModule } from '../,,/../../../common/common.module';
import { MovementOrderStrategyDialogComponent } from './component/movement-order-strategy-dialog/movement-order-strategy-dialog.component';
import { StructureSelectionModule } from '../,,/../../../common/structure-selection/structure-selection.module';
import { ServiceResponseModule } from '@sdbn/common';
import { MovingOrderVehicleSelectionComponent } from './component/moving-order-vehicle-selection/moving-order-vehicle-selection.component';
import { MovementOrderReroutingDialogComponent } from './component/movement-order-rerouting-dialog/movement-order-rerouting-dialog.component';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule as MatTableModule } from '@angular/material/table';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatRadioModule as MatRadioModule } from '@angular/material/radio';


@NgModule({
  declarations: [
    MovementOrdersComponent,
    MovementOrderDetailsComponent,
    MovementOrderStrategyDialogComponent,
    MovingOrderVehicleSelectionComponent,
    MovementOrderReroutingDialogComponent
  ],
  imports: [
    CommonModule,

    CommonUIModule,
    CommonLayoutModule,
    ReactiveFormsModule,
    FormsModule,
    CommonTranslationModule,
    TmcYardCommonModule,
    StructureSelectionModule,
    ServiceResponseModule,
    MatSortModule,
    MatTableModule,
    MatFormFieldModule,
    MatSelectModule,
    MatRadioModule
  ],
  exports: [
    MovementOrdersComponent
  ]
})
export class MovementOrdersModule { }
